<div
  class="ds-notice"
  [class.ds-notice-error]="type === 'error'"
  [class.ds-notice-success]="type === 'success'"
  [class.ds-notice-message]="type === 'message'"
  [attr.role]="type === 'error' ? 'alert' : 'status'"
>
  <!-- Error icon -->
  <svg
    *ngIf="type === 'error'"
    class="ds-notice-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
      fill="#F20D0D"
    />
  </svg>

  <!-- Success icon -->
  <svg
    *ngIf="type === 'success'"
    class="ds-notice-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
      fill="#70C346"
    />
  </svg>

  <!-- Message icon -->
  <svg
    *ngIf="type === 'message'"
    class="ds-notice-icon ds-notice-icon--message-heart"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M13.7906 14.9937C15.0109 13.7736 16.9892 13.7736 18.2095 14.9937L19.2955 16.0797C19.7347 16.519 19.7347 17.2312 19.2955 17.6705C18.8562 18.1098 18.144 18.1097 17.7046 17.6705L16.6187 16.5846C16.277 16.2431 15.7231 16.2431 15.3814 16.5846L14.2955 17.6705C13.8561 18.1098 13.144 18.1098 12.7046 17.6705C12.2653 17.2312 12.2653 16.519 12.7046 16.0797L13.7906 14.9937Z"
      fill="#D2BB9D"
    />
    <path
      d="M12.375 12.7501C12.9963 12.7501 13.5 13.2538 13.5 13.8751C13.5 14.4964 12.9963 15.0001 12.375 15.0001C11.7538 15.0001 11.2501 14.4964 11.25 13.8751C11.25 13.2538 11.7537 12.7501 12.375 12.7501Z"
      fill="#D2BB9D"
    />
    <path
      d="M19.625 12.7501C20.2463 12.7501 20.75 13.2538 20.75 13.8751C20.75 14.4964 20.2463 15.0001 19.625 15.0001C19.0038 15.0001 18.5001 14.4964 18.5 13.8751C18.5 13.2538 19.0037 12.7501 19.625 12.7501Z"
      fill="#D2BB9D"
    />
    <path
      d="M14.625 11.0001C15.2463 11.0001 15.75 11.5038 15.75 12.1251C15.75 12.7464 15.2463 13.2501 14.625 13.2501C14.0038 13.2501 13.5001 12.7464 13.5 12.1251C13.5 11.5038 14.0037 11.0001 14.625 11.0001Z"
      fill="#D2BB9D"
    />
    <path
      d="M17.375 11.0001C17.9963 11.0001 18.5 11.5038 18.5 12.1251C18.5 12.7464 17.9963 13.2501 17.375 13.2501C16.7538 13.2501 16.2501 12.7464 16.25 12.1251C16.25 11.5038 16.7537 11.0001 17.375 11.0001Z"
      fill="#D2BB9D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 6.43711C18.7882 4.25378 22.8211 4.35069 25.5035 6.78281C28.9983 9.95186 28.9989 15.4062 25.5044 18.5758L17.0972 26.2013C16.4741 26.7663 15.526 26.7663 14.9029 26.2013L6.49565 18.5758C3.00121 15.4062 3.00169 9.95185 6.49663 6.78281C9.17901 4.35069 13.2119 4.25377 16 6.43711ZM23.9922 8.4498C21.9809 6.62604 18.869 6.69376 16.941 8.60166C16.4194 9.11767 15.5807 9.1176 15.0591 8.60166C13.1311 6.69376 10.0192 6.62604 8.00786 8.4498C5.49767 10.726 5.49749 14.6328 8.00737 16.9093L16 24.1583L23.9927 16.9093C26.5026 14.6328 26.5023 10.726 23.9922 8.4498Z"
      fill="#D2BB9D"
    />
  </svg>

  <p class="ds-notice-text">{{ message }}</p>

  <button
    *ngIf="!hideClose"
    type="button"
    class="ds-notice-close"
    (click)="onDismiss()"
    [attr.aria-label]="'Close ' + type + ' notice'"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M0.5 0.5L8.5 8.5M8.5 0.5L0.5 8.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
    </svg>
  </button>
</div>
